import React from 'react';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';

/** Shared presentation control; pane state stays with its existing workspace. */
export default function WorkspacePaneToggle({ open, label, onToggle, controls, shortLabel = false }: {
  open: boolean; label: string; onToggle: () => void; controls?: string; shortLabel?: boolean;
}) {
  const action = open ? 'Hide' : 'Show';
  const Icon = open ? PanelLeftClose : PanelLeftOpen;
  return <button type="button" className="arch-btn arch-btn-ghost arch-btn-sm arch-workspace-pane-toggle"
    aria-label={`${action} ${label}`} aria-expanded={open} aria-controls={controls}
    title={`${action} ${label}`} onClick={onToggle}>
    <Icon size={15} aria-hidden="true" /><span>{shortLabel ? action : `${action} ${label}`}</span>
  </button>;
}
